
			
document.addEventListener("DOMContentLoaded", function() {

  const btn = document.querySelector(".bundle-work-popup-btn");
  const popup = document.querySelector(".bundle-rules-popup");
  const closeBtn = document.querySelector(".bundle-popup-close");

  if (btn && popup) {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      popup.classList.add("active");
    });
  }

  if (closeBtn && popup) {
    closeBtn.addEventListener("click", function() {
      popup.classList.remove("active");
    });
  }

});            
// Function to handle checkbox state and button enabling
function handleCheckboxState() {
  const checkbox = document.getElementById('agree');
  const button = document.getElementById('CartDrawer-Checkout');
  
  if (checkbox && button) {
    // Set initial state
    button.disabled = !checkbox.checked;
    
    // Add event listener
    checkbox.addEventListener('change', function() {
      button.disabled = !this.checked;
    });
  }
}

// Initialize on page load
handleCheckboxState();

// Watch for DOM changes (AJAX updates)
const observer = new MutationObserver(function(mutations) {
  // Check if the checkbox or button was added/modified
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length || mutation.type === 'childList') {
      handleCheckboxState();
    }
  });
});

// Start observing the document body for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Alternative: Use event delegation for more efficiency
document.body.addEventListener('change', function(e) {
  if (e.target.id === 'agree') {
    const button = document.getElementById('CartDrawer-Checkout');
    if (button) {
      button.disabled = !e.target.checked;
    }
  }
});